import React, { useId, useState } from 'react';
import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';
import './RichTextDisplay.scss';

const purifyConfig = {
  ALLOWED_TAGS: ['p', 'br', 'strong', 'b', 'em', 'i', 'u', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'a', 'span'],
  ALLOWED_ATTR: ['href'],
  ALLOW_DATA_ATTR: false,
};
const plainText = content => DOMPurify.sanitize(content || '', { ...purifyConfig, RETURN_DOM_FRAGMENT: true }).textContent || '';

const RichTextDisplay = ({ content, className = '', maxLength = null, showReadMore = false, children = null, id }) => {
  const { t } = useTranslation('common');
  const [expanded, setExpanded] = useState(false);
  const generatedId = useId();
  if (!content) return null;
  const contentId = id || generatedId;
  const text = plainText(content);
  const canTruncate = maxLength > 0 && text.length > maxLength;
  const truncated = canTruncate && !expanded;
  return <div className={`rich-text-display ${className}`}>
    {truncated
      ? <div id={contentId} className="rich-text-content"><p>{text.slice(0, maxLength)}…</p></div>
      : <div id={contentId} className="rich-text-content" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content, purifyConfig) }} />}
    {showReadMore && canTruncate && !children && <button type="button" className="toggle-description-btn"
      aria-controls={contentId} aria-expanded={expanded} onClick={() => setExpanded(previous => !previous)}>
      {t(expanded ? 'ui.less' : 'ui.more')}
    </button>}
    {children}
  </div>;
};

export const OfferDescription = ({ content, isExpanded, onToggle }) => {
  const { t } = useTranslation('common');
  const [localExpanded, setExpanded] = useState(false);
  const contentId = useId();
  const expanded = isExpanded ?? localExpanded;
  const canExpand = plainText(content).length > 200;
  const handleToggle = () => {
    if (isExpanded === undefined) setExpanded(!expanded);
    onToggle?.(!expanded);
  };
  return <RichTextDisplay content={content} id={contentId} maxLength={expanded ? null : 200} className="offer-description">
    {canExpand && <button type="button" className="toggle-description-btn" onClick={handleToggle}
      aria-expanded={expanded} aria-controls={contentId}>{t(expanded ? 'ui.less' : 'ui.more')}</button>}
  </RichTextDisplay>;
};

export const TermsDisplay = ({ content, isModal = false }) => (
  <RichTextDisplay content={content} className={`terms-display ${isModal ? 'modal-terms' : ''}`} />
);
export default RichTextDisplay;
